import { Link } from 'react-router-dom';

const articles = [
  {
    id: "1",
    slug: "wanghong-ta-fang-jingren-neimu",
    title: "某千万粉网红塌房内幕曝光，背后金主浮出水面",
    category: "网红爆料",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20smartphone%20screen%20showing%20social%20media%20scandal%20alert%20notification%20with%20red%20warning%20icon%20against%20dark%20blurred%20background%2C%20breaking%20news%20atmosphere%2C%20cinematic%20lighting%2C%20high%20contrast%2C%20editorial%20style%20with%20shallow%20depth%20of%20field%2C%20warm%20amber%20accent%20tones%2C%20minimalist%20composition%2C%20intense%20mood&width=800&height=600&seq=hot-gossip-01&orientation=landscape",
    rank: 1,
  },
  {
    id: "2",
    slug: "mingxing-si-liao-bei-bao-guang",
    title: "顶流明星私聊记录被曝光，内容令人大跌眼镜",
    category: "明星大瓜",
    imageUrl: "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20smartphone%20displaying%20blurred%20chat%20messages%20with%20dramatic%20redacted%20text%20effect%2C%20warm%20ambient%20lighting%20from%20desk%20lamp%2C%20moody%20atmosphere%2C%20cinematic%20noir%20style%2C%20shadows%20and%20light%20interplay%2C%20elegant%20minimal%20composition%2C%20dark%20tones%20with%20warm%20highlights&width=800&height=600&seq=hot-gossip-02&orientation=landscape",
    rank: 2,
  },
  {
    id: "3",
    slug: "zhibo-jian-chao-jia-xian-chang",
    title: "两大主播直播间互撕现场，粉丝集体倒戈",
    category: "直播风波",
    imageUrl: "https://readdy.ai/api/search-image?query=Split%20screen%20streaming%20setup%20with%20dramatic%20red%20and%20blue%20lighting%20contrast%2C%20gaming%20chair%20silhouettes%2C%20digital%20interface%20with%20live%20chat%20scrolling%2C%20intense%20competitive%20atmosphere%2C%20cinematic%20wide%20shot%2C%20editorial%20photography%20style%2C%20dark%20background%20with%20vibrant%20accent%20lighting&width=800&height=600&seq=hot-gossip-03&orientation=landscape",
    rank: 3,
  },
  {
    id: "4",
    slug: "meishi-bozhu-fan-cha-hei-liao",
    title: "美食博主人设崩塌，私下反差行为被扒",
    category: "网红爆料",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20food%20photography%20flat%20lay%20with%20dramatic%20shadow%20casting%20across%20the%20scene%2C%20broken%20plate%20symbolism%2C%20warm%20and%20dark%20contrast%20lighting%2C%20cinematic%20still%20life%20composition%2C%20moody%20editorial%20aesthetic%2C%20rich%20amber%20and%20deep%20brown%20tones%2C%20mysterious%20atmosphere&width=800&height=600&seq=hot-gossip-04&orientation=landscape",
    rank: 4,
  },
  {
    id: "5",
    slug: "duan-shi-pin-da-shen-chao-xi",
    title: "短视频大V被指抄袭，原创作者实名举报",
    category: "抄袭实锤",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20smartphones%20side%20by%20side%20showing%20identical%20content%20with%20red%20circles%20highlighting%20similarities%2C%20dramatic%20comparison%20lighting%2C%20editorial%20evidence%20documentation%20style%2C%20high%20contrast%20with%20warm%20undertones%2C%20minimal%20composition%2C%20intense%20confrontational%20atmosphere&width=800&height=600&seq=hot-gossip-05&orientation=landscape",
    rank: 5,
  },
  {
    id: "6",
    slug: "lian-mai-zhu-bo-nei-hong",
    title: "知名连麦主播团队内讧，合伙人连夜退出",
    category: "直播风波",
    imageUrl: "https://readdy.ai/api/search-image?query=Empty%20streaming%20room%20with%20abandoned%20gaming%20chair%20and%20turned%20off%20ring%20lights%2C%20dramatic%20sunset%20light%20streaming%20through%20window%20blinds%2C%20melancholic%20atmosphere%2C%20cinematic%20interior%20shot%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20editorial%20photography%20style%2C%20storytelling%20composition&width=800&height=600&seq=hot-gossip-06&orientation=landscape",
    rank: 6,
  },
];

export default function HotGossipGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="text-xs font-medium text-accent-600 uppercase tracking-widest mb-2">
            实时热榜
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-tight">
            今日热门
            <br />
            <span className="text-primary-500">瓜田精选</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-accent-300/40 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 text-xs font-medium text-accent-700 bg-background-50/90 backdrop-blur-sm rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
                {article.rank <= 3 && (
                  <div className="absolute top-3 right-3 w-7 h-7 flex items-center justify-center bg-primary-500 text-background-50 text-xs font-bold rounded-full">
                    {article.rank}
                  </div>
                )}
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-foreground-500">
                    <i className="ri-time-line mr-1"></i>
                    刚刚更新
                  </span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.rank === 1 ? '98.7' : article.rank === 2 ? '86.3' : article.rank === 3 ? '72.5' : article.rank === 4 ? '65.1' : article.rank === 5 ? '51.8' : '43.2'}万
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 md:mt-12 text-center">
          <Link
            to="/category/wanghong-baoliao"
            className="inline-flex items-center gap-2 px-8 py-3 text-sm font-semibold text-foreground-700 border-2 border-foreground-300/40 rounded-full hover:border-primary-400 hover:text-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部瓜田
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}